// Import global utils
import { getURLParameter } from '@automator/shared/utils/get-url-parameter';
import { isEmpty } from '@automator/shared/utils/is-empty';

import {
	getDOMElements
} from '../common/utilities.js';

import ItemCreatorIntegrations  from './integrations-grid.js';

import MetaboxItems             from '../metabox/items.js';
import MetaboxFooter            from '../metabox/footer.js';

class Triggers {
	constructor(){
		// Create console group
		// console.group( 'Triggers' );

		// Get and clear metabox
		let metabox = getDOMElements( 'metabox', { type: 'trigger' } ).get(0);
		metabox.innerHTML = '';

		// Get recipe triggers
		let triggers = UncannyAutomator._recipe.triggers.items;

		// Insert the and/or selector
		metabox.insertAdjacentHTML( 
			'beforeEnd', 
			`<ua-builder-items-triggers-logic></ua-builder-items-triggers-logic>` 
		);

		// const $triggerItemList = document.createElement( 'uap-builder-item-trigger-list' );

		// $triggerItemList.logic = UncannyAutomator._recipe.triggers.logic;
		// $triggerItemList.items = UncannyAutomator._recipe.triggers.items;

		// Check if it has triggers
		if ( ! isEmpty( triggers ) ){
			// metabox.insertAdjacentElement( 
			// 	'beforeEnd', 
			// 	$triggerItemList
			// );

			// Render items
			new MetaboxItems( 'trigger', triggers, false );

			// Create metabox footer
			new MetaboxFooter( 'trigger' );

			// Check if we have to show the integrations on load
			if ( this.isContinuingIntegrationConnection() ){
				// Render the integrations list
				new ItemCreatorIntegrations( 'trigger' );
			}
		}
		else {
			new ItemCreatorIntegrations( 'trigger' );

			// Create metabox footer
			new MetaboxFooter( 'trigger' );
		}

		// Close console group
		// console.groupEnd();
	}

	isContinuingIntegrationConnection(){
		return getURLParameter( 'ua_connecting_integration' ) == 1 && getURLParameter( 'ua_connecting_integration_context' ) == 'trigger';
	}
}

export default Triggers;